import { render, staticRenderFns } from "./clientOnboard.vue?vue&type=template&id=7b08fae2&"
import script from "./clientOnboard.vue?vue&type=script&lang=js&"
export * from "./clientOnboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports